module.exports = __webpack_public_path__ + "static/media/copy.a3c00457.svg";